import React, { useEffect, useState } from "react";
import { Editor } from "primereact/editor";
import { Button } from "primereact/button";
import { T } from "services/lang/LanguageService";
import FreeText from "./FreeText";

const FreeTextDefaultConfig = {
  content: "",
};

interface FreeTextConfig {
  content: string;
}

interface FreeTextEditorProps {
  config: FreeTextConfig;
  onConfigChange: (config: FreeTextConfig) => void;
}

const FreeTextEditor = ({ config, onConfigChange }: FreeTextEditorProps) => {
  let conf = config ?? FreeTextDefaultConfig;

  if (Object.keys(conf).length === 0) {
    conf = FreeTextDefaultConfig;
  }

  const [value, setValue] = useState<string | null>(conf.content);

  useEffect(() => {
    onConfigChange({ content: value ?? "" });
  }, [value]);

  const renderHeader = () => {
    return (
      <span className="ql-formats">
        <Button className="ql-bold" aria-label="Bold" />
        <Button className="ql-italic" aria-label="Italic" />
        <Button className="ql-underline" aria-label="Underline" />
        <Button className="ql-link" aria-label="Link" />
        <Button className="ql-image" aria-label="Image" />
        <Button className="ql-clean" aria-label="Clean" />
        <Button className="ql-code" aria-label="Code" />
        <select className="ql-align" aria-label="Align">
          <option selected />
          <option value="center" />
          <option value="right" />
          <option value="justify" />
        </select>
      </span>
    );
  };

  return (
    <div>
      <Editor
        value={value ?? ""}
        onTextChange={e => setValue(e.htmlValue)}
        headerTemplate={renderHeader()}
        style={{ height: "320px" }}
      />
      <h4 className="border-bottom-1 pb-2 mb-2">{T("word.preview")}</h4>
      <FreeText content={value ?? ""} />
    </div>
  );
};

export default FreeTextEditor;
